export class Constants {
  public static readonly walletLink =
    "https://links.kimgbister.com/bireysel-landing-button";

  public static readonly answerModalYaaniPrizeInfoBoxTitleWrong = "Kazandın";
  public static readonly answerModalYaaniPrizeInfoBoxTitleCorrect = "Kazandın";
  public static readonly answerModalYaaniPrizeInfoBoxTitleExtra = "Hediye";

  public static readonly answerModalYaaniPrizeInfoBoxPrize2000Points =
    "1.000 FreeByte";
  public static readonly answerModalYaaniPrizeInfoBoxPrize1000Points =
    "500 FreeByte";
  public static readonly answerModalYaaniPrizeInfoBoxPrizeExtra2000Points =
    "+1.000 FreeByte";

  public static readonly bannerImg =
    "https://static.4play.com.tr/kazan-kazan/29ekim.png";
}
